import { render } from "./TemplateExportButton.vue?vue&type=template&id=546b82a2"
import script from "./TemplateExportButton.vue?vue&type=script&lang=js"
export * from "./TemplateExportButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__